tp = window.tp || [];

tp.push( [ 'setZone', 'Web' ] );

if ( pianoVars.contentCreated ) {
	tp.push( [ 'setContentCreated', pianoVars.content_created ] );
}

if ( pianoVars.is_sponsored ) {
	tp.push( [ 'setContentIsNative', pianoVars.is_sponsored ] );
}

if ( pianoVars.article_section ) {
	tp.push( [ 'setContentSection', pianoVars.article_section ] );
}

if ( pianoVars.article_paywall ) {
	tp.push( [ 'setCustomVariable', 'articleRestriction', pianoVars.article_paywall ] );
}

if ( pianoVars.use_client_side_paywall ) {
	tp.push( [ 'setCustomVariable', 'useClientSidePaywall', pianoVars.use_client_side_paywall ] );
}

if ( pianoVars.author ) {
	tp.push( [ 'setCustomVariable', 'setContentAuthor', pianoVars.author ] );
}

if ( pianoVars.keywords && Array.isArray( pianoVars.keywords ) && pianoVars.keywords.length > 0 ) {
	tp.push( [ 'setTags', pianoVars.keywords ] );
}

if ( pianoVars.subject ) {
	tp.push( [ 'setCustomVariable', 'subject', pianoVars.subject ] );
}

if ( pianoVars.nested_subject ) {
	tp.push( [ 'setCustomVariable', 'nestedSubject', pianoVars.nested_subject ] );
}

if ( pianoVars.barrier_type ) {
	tp.push( [ 'setCustomVariable', 'barrierType', pianoVars.barrier_type ] );
}
